import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';

const mock = [
  {
    title: 'Academic',
    subtitle:
      'There is no secret to success. It is the result of hard work, preparation and learning from failure.',
    icon: 'https://www.pngkey.com/png/full/509-5098931_as-olympiad-icon.png',
  },
  {
    title: 'Co-Scholastic',
    subtitle:
      '',
    icon: 'https://image.pngaaa.com/504/21504-middle.png',
  },
  {
    title: 'Scholastic',
    subtitle:
      '.',
    icon: 'https://image.pngaaa.com/504/21504-middle.png',
    
  },
  {
    title: 'Olympiad',
    subtitle:
      '',
    icon: 'https://www.pngkey.com/png/full/509-5098931_as-olympiad-icon.png',
  },
];

const Curology = () => {
  return (
    <Box>
      
      <Box marginBottom={4}>
        {/* <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'secondary'}
        >
          Compatibility
        </Typography> */}
        <Typography fontWeight={700} variant={'h4'}>
          Achievements
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid item xs={12} md={3} key={i}>
            <Box
              width={1}
              height={1}
              data-aos={'fade-up'}
              data-aos-delay={i * 100}
              data-aos-offset={100}
              data-aos-duration={600}
            >
              <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
              >
                <Box
                  component={Avatar}
                  width={80}
                  height={80}
                  marginBottom={2}
                  src={item.icon}
                />
                <Typography
                  variant={'h6'}
                  gutterBottom
                  fontWeight={500}
                  align={'center'}
                >
                  {item.title}
                </Typography>
                <Typography align={'center'} color="text.secondary">
                  {item.subtitle}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Curology;
